import './constants/enums.js';
import './constants/env.js';
import { CLOUDFRONT_URI, OPEN_EDITION_SONG_SLOTS, OPEN_EDITION_MAX_MINTABLE } from './constants/constants.js';
import './constants/chain.js';
import './constants/notifications.js';
import './constants/creditSplits.js';
import './constants/season.js';
import './constants/transaction.js';
import './constants/genre.js';
import './constants/license.js';
import './constants/uploadSteps.js';
import './constants/songKey.js';
import '@total-typescript/ts-reset';
import { WebappUrl } from './constants/embeds.js';
import { startOfDay, subMinutes } from 'date-fns';

const ISO_DATE_TRUNCATE_TO_YYYYMMDD_OFFSETS = [0, 10];
const getCommentTimeStamp = (args) => {
  const { trackDuration, totalSlots, songSlot } = args;
  const isOpenEdition = totalSlots >= OPEN_EDITION_MAX_MINTABLE;
  const TOTAL_SLOTS = isOpenEdition ? OPEN_EDITION_SONG_SLOTS : totalSlots;
  const halfSlotSize = trackDuration / TOTAL_SLOTS / 2;
  return trackDuration / TOTAL_SLOTS * (songSlot + 1) - halfSlotSize;
};
const secondsToTime = (seconds) => {
  const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
  const m = Math.floor(seconds % 3600 / 60).toString().padStart(2, "0");
  const s = Math.floor(seconds % 60).toString().padStart(2, "0");
  return h === "00" ? `${m}:${s}` : `${h}:${m}:${s}`;
};
function getCDNUrl({ s3FileKey }) {
  return encodeURI(`https://${CLOUDFRONT_URI}/${s3FileKey}`);
}
function getReleasePageUrl({
  artistSoundHandle,
  releaseTitleSlug
}) {
  const url = new URL(WebappUrl().toString());
  url.pathname = `/${artistSoundHandle}/${releaseTitleSlug}`;
  return encodeURI(url.href);
}
function getLastDayForViralChart({
  periodEndExclusive
}) {
  return startOfDay(subMinutes(periodEndExclusive, 1));
}
function getReleaseChartLastDateOfPeriodInput(chart) {
  return getLastDayForViralChart(chart).toISOString().slice(...ISO_DATE_TRUNCATE_TO_YYYYMMDD_OFFSETS);
}
function getReleaseChartPathname(chart) {
  const lastDateOfChartFormatted = getReleaseChartLastDateOfPeriodInput(chart);
  return `/charts/viral/${lastDateOfChartFormatted}`;
}
function getFromList(list, cb) {
  if (!list)
    return null;
  let index = 0;
  for (const listValue of list) {
    const value = cb(listValue, index++);
    if (value != null && value !== false)
      return value;
  }
  return null;
}
function getManyFromList(list, cb) {
  const values = [];
  if (!list)
    return values;
  let index = 0;
  for (const listValue of list) {
    const value = cb(listValue, index++);
    if (value != null && value !== false)
      values.push(value);
  }
  return values;
}
function exhaustiveGuard(_value) {
  throw new Error(`Exhaustive guard reached with value ${_value}`);
}
function replaceUndefined(original, newValue) {
  if (original === void 0)
    return newValue;
  return original;
}
function noop(..._args) {
}

export { exhaustiveGuard, getCDNUrl, getCommentTimeStamp, getFromList, getLastDayForViralChart, getManyFromList, getReleaseChartLastDateOfPeriodInput, getReleaseChartPathname, getReleasePageUrl, noop, replaceUndefined, secondsToTime };
